/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import HorizontalTeamCard from "parts/Cards/TeamCards/HorizontalTeamCard";

// Images
import team1 from "assets/images/6.jpg";
import team2 from "assets/images/22.jpg";
import team3 from "assets/images/16.jpg";
import team4 from "assets/images/35.jpg";

function Team() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="info"
      position="relative"
      py={6}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={8} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
            Why Us?
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
            Choosing HP Tech Solutions for your AI and technology needs means partnering with a trusted leader in innovation and artificial intelligence solutions. We stand out for our commitment to delivering cutting-edge, data-driven technologies designed to propel your business forward. Here’s why businesses choose us:</MKTypography>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team1}
                name="Unmatched Expertise"
                position={{ color: "info", label: "user-friendly" }}
                description="A team of skilled professionals with extensive AI experience."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={1}>
              <HorizontalTeamCard
                image={team2}
                name="Tailored Strategies"
                position={{ color: "info", label: "threat detection" }}
                description="Custom-designed AI solutions that align with your business objectives."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team3}
                name="Innovative Tools"
                position={{ color: "info", label: "specific business goals" }}
                description="Access to the latest AI technologies to maximize value."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Proven Impact"
                position={{ color: "info", label: "maximize ROI" }}
                description="A history of delivering transformative results for diverse industries."
              />
            </MKBox>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox mb={{ xs: 1, lg: 0 }}>
              <HorizontalTeamCard
                image={team4}
                name="Continuous Support"
                position={{ color: "info", label: "maximize ROI" }}
                description="Comprehensive assistance from inception to implementation and beyond."
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Team;
